'use strict';

angular.module('chatEngine.engines', [
    'chatEngine.engines.base',
    'chatEngine.engines.custom',
    'chatEngine.engines.redirect',
    'chatEngine.engines.keyword',
    'chatEngine.resources',
    'chatEngine.services',
    'chatEngine.dialog',
    'chatEngine.messageEditor',
    'ui.sortable',
    'ngTagsInput',
    'ui.bootstrap'
])

.controller('EnginesCtrl', ['$scope', 'Engine', 'Dialog', 'LoadingDialog', '$location',
    function($scope, Engine, Dialog, LoadingDialog, $location) {
    $scope.loadedEngines = false;
    $scope.loadingError = false;
    $scope.enginesData = Engine.getData();
    $scope.enginesMeta = Engine.getMeta();

    $scope.init = function() {
        Engine.query(function(engines) {
            $scope.enginesData = Engine.setData(engines);
            $scope.loadedEngines = true;
        }, function() {
            fetchError();
        });
    };

    $scope.isDefaultEngine = function(engineMeta) {
        var engineData = Engine.getDataByType(engineMeta.type);
        return engineData !== null && engineData.default === true;
    };

    $scope.goToEngine = function(engineData) {
        $location.path('/engine/' + engineData.id);
    };

    $scope.fetchEngine = function(engineMeta) {
        var engineData = Engine.getDataByType(engineMeta.type);
        if (engineData === null) {
            var newEngine = new Engine({type: engineMeta.type});
            var loadingDialog = LoadingDialog.show('Fetching engine, please wait...');

            newEngine.$save(function(engineData) {
                $scope.enginesData[engineData.id] = engineData;

                LoadingDialog.hide(loadingDialog).then(function() {
                    $scope.goToEngine(engineData);
                });
            }, function() {
                LoadingDialog.hide(loadingDialog).then(fetchError);
            });
        } else {
            $scope.goToEngine(engineData);
        }
    };

    $scope.$watch('enginesData', function() {
        Engine.setData($scope.enginesData);
    }, true);

    function fetchError() {
        $scope.loadingError = true;
        Dialog.alert('Error', 'Something went wrong while fetching your engine, please try again later.');
    }

    $scope.init();
}]);
